import { rootApiUrl } from "../jefdaqApi";

export const fetchFeatureAPI = fetch(rootApiUrl.toString(), {
  headers: { "Content-Type": "application/json" },
}).then((res) => res.json());
